export const tooltipPositions = {
    'top-right': (bounding: DOMRect) => ({
        style: {
            top: bounding.bottom,
            left: bounding.left + bounding.width + 25,
            transform: 'translateY(-100%)'
        },
        polygonStyle: {},
        polygonClassName: 'left-0 bottom-[10px] translate-x-[-98%] -rotate-90'
    }),
    'bottom-right': (bounding: DOMRect, offsetWidth: number) => {
        let diff = 0;
        if (bounding.left + offsetWidth > window.innerWidth) {
            diff = bounding.left + offsetWidth - window.innerWidth;
        }

        const additional = diff > 0 ? 10 : 0;
        return {
            style: {
                top: bounding.bottom + 10,
                left: bounding.left - diff - additional
            },
            polygonStyle: { left: bounding.width / 2 + diff },
            polygonClassName: `top-0 translate-y-[-100%]`
        };
    },
    'bottom-left': (bounding: DOMRect) => ({
        style: {
            top: bounding.bottom + 10,
            right: window.innerWidth - bounding.right - 10
        },
        polygonStyle: { right: bounding.width / 2 },
        polygonClassName: `top-0 translate-y-[-100%]`
    }),
};

export const getTooltipPosition = (bounding: DOMRect, offsetWidth = 340, forceBelow = false, customPosition?: keyof typeof tooltipPositions) => {
    if (customPosition) return tooltipPositions[customPosition](bounding, offsetWidth);

    if (!forceBelow && bounding.right + 300 < window.innerWidth) return tooltipPositions['top-right'](bounding);

    return tooltipPositions['bottom-right'](bounding, offsetWidth);
};
